module.exports = __webpack_public_path__ + "static/media/french-categories.0f451433.jpg";